import React from "react";

// import router
import { Route, Redirect } from "react-router-dom";

// import constants
import { USER_DATA } from "../helpers/constants";
// import Header from "../components/layout/Header";
import NewHeader from "../components/layout/NewHeader";
import Footer from "../components/layout/Footer";
import ErrorBoundary from "../../src/components/common/ErrorBoundary"

const AppRoute = ({
  component: Component,
  layout: Layout,
  isProtected,
  isPreloader,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => {
      if (isProtected && !localStorage.getItem(USER_DATA)) {
        return (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        );
      }
      let showHeaderFooter = props?.location?.pathname?.includes("/articles/");
      let showFooter = props?.location?.pathname?.includes("/opportunites/");

      return (
        <>
        <ErrorBoundary >
          {!isPreloader && !showHeaderFooter ? <NewHeader /> : null}
          <Layout>
            <Component {...props} />
          </Layout>
          {!isPreloader && !showFooter && !showHeaderFooter ? <Footer /> : null}
          </ErrorBoundary>
        </>
      );
    }}
  />
);
export default AppRoute;
